export const BALANCE_CHART_NAME = 'Balance';
export const CONTRIBUTION_CHART_NAME = 'Money In/Out';
